import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { GlobalVariable } from '../app.global';


/**
 * @author Wesley Mascarenhas
 * @version $Id: authentication.service.ts 82141 2018-03-13 00:22:47Z thiago.h.neri $
 */
@Injectable()
export class AuthenticationService {

  private baseURL: string;
  private baseURLCompanyInfo: string;
  private requestOptions: RequestOptions;
 
  public authenticatedUser: any;
 
  constructor(private http: Http) {
    this.baseURL = GlobalVariable.BASE_URL_API + '/datapackusermanager';
    this.baseURLCompanyInfo =  GlobalVariable.BASE_URL_API + '/datapackcompanyinfo';
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json; charset=UTF-8');
    headers.append('Accept', 'application/json');
    headers.append("Cache-Control", "no-cache");
    headers.append("Pragma", "no-cache");
    this.requestOptions = new RequestOptions({
      headers: headers
    });
  }

  private convertResponse(response: Observable<Response>) {
    return response
      .map((res: Response) => {
        this.authenticatedUser = res.json();
        return this.authenticatedUser;
      })
      .catch((err: Response) => Observable.throw(err.json ? err.json() : err) );
  }

  public login(user : string, password:string) {
    return this.convertResponse(this.http.post(this.baseURLCompanyInfo,{user, password,action:'login'}, this.requestOptions))
      .map((json: any) => {
        this.authenticatedUser = json;
        return this.authenticatedUser;
      });
  }

  public logout() {
    return this.convertResponse(this.http.post(this.baseURLCompanyInfo,{action:'logout'}, this.requestOptions))
      .map((json: any) => {
        this.authenticatedUser = json;
        return this.authenticatedUser;
      });
  }

  public requestNewPassword(user : string, email:string) {
    return this.convertResponse(this.http.post(this.baseURLCompanyInfo,{user, email,action:'esqueciMinhaSenha'}, this.requestOptions))
      .map((json: any) => {
        this.authenticatedUser = json;
        return this.authenticatedUser;
      });
  }

  public  ChangePassword(user : string, newPassword:string, password : string ){
      return this.convertResponse(this.http.post(this.baseURLCompanyInfo,{user,newPassword,password,action:'alterarSenha'}, this.requestOptions))
    .map((json: any) => {
      this.authenticatedUser = json;
      return this.authenticatedUser;
    });
  }

  public getWelcomeText(){
    return this.convertResponse(this.http.post(this.baseURLCompanyInfo,{action:'welcome'}, this.requestOptions))
    .map((json: any) => {
      this.authenticatedUser = json;
      return this.authenticatedUser;
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts